<template>
	<div class="layout-footer">
		<span class="footer-text" style="margin-right: 5px">
			{{$t('copyright')}} <a href="https://propulsoft.ca/"> Propulsoft.ca</a>
		</span>
	</div>
</template>

<script>
	export default {
		name: "AppFooter"
	}
</script>

<style scoped>

</style>